import { render, staticRenderFns } from "./CheckableColumn.vue?vue&type=template&id=39c90e5a&"
import script from "./CheckableColumn.vue?vue&type=script&lang=js&"
export * from "./CheckableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports